<template>
  <div class="header-wrapper">
    <div class="icon"><img :src="icon"></img></div>
    <div class="header">{{ header }}</div>
  </div>
</template>

<script>
export default {
  props: ['icon', 'header'],
};
</script>

<style scoped>
.header-wrapper {
  text-align: center;
  font-weight: 700;
  font-size: 0;
}

.header-wrapper > div {
  color: #000;
  display: inline-block;
  border-bottom: 5px solid #000;
  font-size: 30px;
}

.icon {
}

.icon img {
  height: 30px;
  margin-bottom: 4px;
  margin-top: -2px;
}
</style>
